import { DashboardLayout } from "../components/dashboard/dashboard-layout";
import { PageHeader } from "../components/dashboard/page-header";
import { 
  Gift, 
  Star, 
  Users, 
  TrendingUp,
  Clock,
  Settings,
  Plus,
  ArrowUpRight,
  Sparkles,
  Award,
  Target
} from "lucide-react";

export default function LoyaltyManagerPage() {
  return (
    <DashboardLayout>
      <PageHeader 
        title="Loyalty Manager" 
        description="Manage customer loyalty programs and rewards"
      />
      
      {/* Coming Soon Hero Section */}
      <div className="text-center py-16 mb-8">
        <div className="max-w-2xl mx-auto">
          <div className="mb-8">
            <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-gray-100 dark:bg-gray-800 mb-6">
              <Gift className="h-10 w-10 text-gray-500 dark:text-gray-400" />
            </div>
            <h1 className="text-4xl font-bold mb-4">Coming Soon</h1>
            <p className="text-xl text-gray-500 dark:text-gray-400 mb-8">
              We're building an advanced loyalty management system to help you create, manage, and optimize customer loyalty programs.
            </p>
          </div>
          
          <div className="grid gap-6 md:grid-cols-3 mb-12">
            <div className="bg-white dark:bg-gray-900 rounded-xl shadow-sm border border-gray-200 dark:border-gray-800 p-6">
              <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-gray-100 dark:bg-gray-800 mb-4 mx-auto">
                <Star className="h-6 w-6 text-gray-500 dark:text-gray-400" />
              </div>
              <h3 className="text-lg font-semibold mb-2">Points System</h3>
              <p className="text-sm text-gray-500 dark:text-gray-400">
                Create flexible point-based reward systems with custom earning and redemption rules.
              </p>
            </div>
            
            <div className="bg-white dark:bg-gray-900 rounded-xl shadow-sm border border-gray-200 dark:border-gray-800 p-6">
              <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-gray-100 dark:bg-gray-800 mb-4 mx-auto">
                <Award className="h-6 w-6 text-gray-500 dark:text-gray-400" />
              </div>
              <h3 className="text-lg font-semibold mb-2">Tier Management</h3>
              <p className="text-sm text-gray-500 dark:text-gray-400">
                Set up customer tiers with exclusive benefits and automatic progression tracking.
              </p>
            </div>
            
            <div className="bg-white dark:bg-gray-900 rounded-xl shadow-sm border border-gray-200 dark:border-gray-800 p-6">
              <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-gray-100 dark:bg-gray-800 mb-4 mx-auto">
                <Target className="h-6 w-6 text-gray-500 dark:text-gray-400" />
              </div>
              <h3 className="text-lg font-semibold mb-2">Campaign Analytics</h3>
              <p className="text-sm text-gray-500 dark:text-gray-400">
                Track program performance with detailed analytics and customer engagement metrics.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Preview Stats Cards */}
      <div className="grid gap-4 sm:gap-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 mb-8">
        <div className="bg-white dark:bg-gray-900 rounded-xl shadow-sm overflow-hidden border border-gray-200 dark:border-gray-800 p-5">
          <div className="flex items-center justify-between mb-2">
            <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400">Active Members</h3>
            <div className="p-2 rounded-full bg-gray-100 dark:bg-gray-800">
              <Users className="h-5 w-5 text-gray-500 dark:text-gray-400" />
            </div>
          </div>
          <div className="flex items-baseline">
            <span className="text-3xl font-bold">--</span>
            <span className="ml-2 text-sm font-medium flex items-center text-gray-400">
              <ArrowUpRight className="h-3 w-3 mr-1" />
              Coming Soon
            </span>
          </div>
          <div className="mt-1 text-xs text-gray-500 dark:text-gray-400">Loyalty program members</div>
        </div>
        
        <div className="bg-white dark:bg-gray-900 rounded-xl shadow-sm overflow-hidden border border-gray-200 dark:border-gray-800 p-5">
          <div className="flex items-center justify-between mb-2">
            <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400">Points Issued</h3>
            <div className="p-2 rounded-full bg-gray-100 dark:bg-gray-800">
              <Star className="h-5 w-5 text-gray-500 dark:text-gray-400" />
            </div>
          </div>
          <div className="flex items-baseline">
            <span className="text-3xl font-bold">--</span>
            <span className="ml-2 text-sm font-medium flex items-center text-gray-400">
              <ArrowUpRight className="h-3 w-3 mr-1" />
              Coming Soon
            </span>
          </div>
          <div className="mt-1 text-xs text-gray-500 dark:text-gray-400">Total points distributed</div>
        </div>
        
        <div className="bg-white dark:bg-gray-900 rounded-xl shadow-sm overflow-hidden border border-gray-200 dark:border-gray-800 p-5">
          <div className="flex items-center justify-between mb-2">
            <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400">Redemptions</h3>
            <div className="p-2 rounded-full bg-gray-100 dark:bg-gray-800">
              <Gift className="h-5 w-5 text-gray-500 dark:text-gray-400" />
            </div>
          </div>
          <div className="flex items-baseline">
            <span className="text-3xl font-bold">--</span>
            <span className="ml-2 text-sm font-medium flex items-center text-gray-400">
              <ArrowUpRight className="h-3 w-3 mr-1" />
              Coming Soon
            </span>
          </div>
          <div className="mt-1 text-xs text-gray-500 dark:text-gray-400">Rewards redeemed</div>
        </div>
        
        <div className="bg-white dark:bg-gray-900 rounded-xl shadow-sm overflow-hidden border border-gray-200 dark:border-gray-800 p-5">
          <div className="flex items-center justify-between mb-2">
            <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400">Engagement Rate</h3>
            <div className="p-2 rounded-full bg-gray-100 dark:bg-gray-800">
              <TrendingUp className="h-5 w-5 text-gray-500 dark:text-gray-400" />
            </div>
          </div>
          <div className="flex items-baseline">
            <span className="text-3xl font-bold">--</span>
            <span className="ml-2 text-sm font-medium flex items-center text-gray-400">
              <ArrowUpRight className="h-3 w-3 mr-1" />
              Coming Soon
            </span>
          </div>
          <div className="mt-1 text-xs text-gray-500 dark:text-gray-400">Program participation</div>
        </div>
      </div>

      {/* Feature Preview Cards */}
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        <div className="bg-white dark:bg-gray-900 rounded-xl shadow-sm overflow-hidden border border-gray-200 dark:border-gray-800 hover:shadow-md transition-all duration-200">
          <div className="p-6">
            <div className="flex items-center justify-between mb-4">
              <div className="p-3 rounded-full bg-gray-100 dark:bg-gray-800">
                <Sparkles className="h-6 w-6 text-gray-500 dark:text-gray-400" />
              </div>
              <span className="text-xs px-2 py-1 rounded-full bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400">
                Coming Soon
              </span>
            </div>
            <h3 className="text-lg font-semibold mb-2">Reward Campaigns</h3>
            <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">
              Create targeted campaigns with personalized rewards based on customer behavior and preferences.
            </p>
            <div className="flex items-center text-sm text-gray-400">
              <Clock className="h-4 w-4 mr-2" />
              <span>In Development</span>
            </div>
          </div>
        </div>

        <div className="bg-white dark:bg-gray-900 rounded-xl shadow-sm overflow-hidden border border-gray-200 dark:border-gray-800 hover:shadow-md transition-all duration-200">
          <div className="p-6">
            <div className="flex items-center justify-between mb-4">
              <div className="p-3 rounded-full bg-gray-100 dark:bg-gray-800">
                <Settings className="h-6 w-6 text-gray-500 dark:text-gray-400" />
              </div>
              <span className="text-xs px-2 py-1 rounded-full bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400">
                Coming Soon
              </span>
            </div>
            <h3 className="text-lg font-semibold mb-2">Program Configuration</h3>
            <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">
              Configure point values, tier thresholds, and reward catalogs with an intuitive interface.
            </p>
            <div className="flex items-center text-sm text-gray-400">
              <Clock className="h-4 w-4 mr-2" />
              <span>In Development</span>
            </div>
          </div>
        </div>

        <div className="bg-white dark:bg-gray-900 rounded-xl shadow-sm overflow-hidden border border-gray-200 dark:border-gray-800 hover:shadow-md transition-all duration-200">
          <div className="p-6">
            <div className="flex items-center justify-between mb-4">
              <div className="p-3 rounded-full bg-gray-100 dark:bg-gray-800">
                <Plus className="h-6 w-6 text-gray-500 dark:text-gray-400" />
              </div>
              <span className="text-xs px-2 py-1 rounded-full bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400">
                Coming Soon
              </span>
            </div>
            <h3 className="text-lg font-semibold mb-2">Integration Hub</h3>
            <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">
              Seamlessly integrate with your existing e-commerce platform and marketing tools.
            </p>
            <div className="flex items-center text-sm text-gray-400">
              <Clock className="h-4 w-4 mr-2" />
              <span>In Development</span>
            </div>
          </div>
        </div>
      </div>

      {/* Notification Banner */}
      <div className="mt-8 bg-gray-50 dark:bg-gray-800/50 rounded-xl border border-gray-200 dark:border-gray-700 p-6">
        <div className="flex items-start gap-4">
          <div className="p-2 rounded-full bg-gray-100 dark:bg-gray-800">
            <Gift className="h-5 w-5 text-gray-500 dark:text-gray-400" />
          </div>
          <div className="flex-1">
            <h4 className="font-semibold mb-2">Get Notified When Available</h4>
            <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">
              Be the first to know when our loyalty management features go live. We're working hard to bring you the most comprehensive loyalty program tools.
            </p>
            <button className="px-4 py-2 bg-gray-900 dark:bg-gray-100 text-white dark:text-gray-900 rounded-lg text-sm font-medium hover:bg-gray-800 dark:hover:bg-white transition-all duration-200">
              Notify Me
            </button>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
}
